import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";
// 双清订单列表
export const getDoubleList = (params) => {
  return axios.request({
    url: `/doubleClearance`,
    method: "get",
    params,
  });
};
// 双清订单详情
export const getDoubleDetails = (id) => {
  return axios.request({
    url: `/doubleClearance/info/${id}`,
    method: "get",
  });
};

// 打印双清面单
export const printDouble = (data) => {
  return axios.request({
    url: `/go/drawPdf/clearance/${data.id}` + "?type=" + data.type,
    method: "post",
    data,
  });
};

// 获取服务
export const getService = () => {
  return axios.request({
    url: `/doubleClearance/getService`,
    method: "get",
  });
};
// 获取地址信息
export const getAddress = () => {
  return axios.request({
    url: `/doubleClearance/address`,
    method: "get",
  });
};

// 获取服务国家
export const getServiceCountry = () => {
  return axios.request({
    url: `/doubleClearance/country`,
    method: "get",
  });
};

export const doubleCreate = (data) => {
  return axios.request({
    url: `/doubleClearance/create`,
    method: "post",
    data,
  });
};

export const getContacts = () => {
  return axios.request({
    url: `/doubleClearance/getExtendBaseParam`,
    method: "get",
  });
};

export const getDoubleInfo = (num) => {
  return axios.request({
    url: `/doubleClearance/getExtendData/${num}`,
    method: "get",
  });
};

export const getSafePlanValues = (num, calculateValue, safePlanId) => {
  return axios.request({
    url: `/doubleClearance/getSafePlan/${num}?calculateValue=${calculateValue}&safePlanId=${safePlanId}`,
    method: "get",
  });
}

export const exportSelection = (params) => {
  return axios.request({
    url: `/doubleClearanceExport`,
    method: "post",
    params,
  });
}

export const saveDoubleInfo = (num, data) => {
  return axios.request({
    url: `/doubleClearance/saveExtend/${num}`,
    method: "post",
    data,
  });
};

export const confirmDoubleInfo = (num, data) => {
  return axios.request({
    url: `/doubleClearance/extConfirmed/${num}`,
    method: "post",
    data,
  });
};

export const getDoubleBill = (num, params) => {
  return axios.request({
    url: `/doubleClearance/listOfFees/${num}`,
    method: "get",
    params,
  });
};

export const getDoubleContents = () => {
  return axios.request({
    url: `/doubleClearance/contacts`,
    method: "get",
  });
};

export const getDoubleItem = () => {
  return axios.request({
    url: `/doubleClearance/expenseItem`,
    method: "get",
  });
};

export const getItem = () => {
  return axios.request({
    url: `/common/expense`,
    method: "get",
  });
};

export const addDoubleBill = (num, data) => {
  return axios.request({
    url: `/doubleClearance/addFinance/${num}`,
    method: "post",
    data,
  });
};

export const saveDoubleBill = (num, data) => {
  return axios.request({
    url: `/doubleClearance/saveFinance/${num}`,
    method: "post",
    data,
  });
};

export const auditBill = (num, data) => {
  return axios.request({
    url: `/doubleClearance/auditFee/${num}`,
    method: "post",
    data,
  });
};

export const delBill = (num, data) => {
  return axios.request({
    url: `/doubleClearance/removeFee/${num}`,
    method: "delete",
    data,
  });
};

export const getItemBill = (num, id) => {
  return axios.request({
    url: `/doubleClearance/readFinance/${num}/${id}`,
    method: "get",
  });
};

export const updateBill = (data) => {
  return axios.request({
    url: "/doubleClearance/upload",
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data: data,
  });
};

export const fileRead = () => {
  return axios.request({
    url: `/doubleClearance/fileRead`,
    method: "get",
  });
};

export const getDoubleTotal = (id, params) => {
  return axios.request({
    url: `/doubleClearance/totalAmount/${id}`,
    method: "get",
    params,
  });
};

export const getBillCurrency = (id) => {
  return axios.request({
    url: `/doubleClearance/getCurrency/${id}`,
    method: "get",
  });
};

export const saveCurrency = (id, data) => {
  return axios.request({
    url: `/doubleClearance/saveCurrency/${id}`,
    method: "post",
    data,
  });
};

export const getB2bConfig = () => {
  return axios.request({
    url: `/doubleClearance/config`,
    method: "get",
  });
};

export const log = (data) => {
  return axios.request({
    url: `/doubleClearance/log/` + data.airwayNumber,
    method: "get",
  });
};

export const getB2bInbound = (id) => {
  return axios.request({
    url: `/warehouse/inbound/getRecord/${id}`,
    method: "get",
  });
};

export const addB2bInbound = (id, data) => {
  return axios.request({
    url: `/warehouse/inbound/addRecord/${id}`,
    method: "post",
    data,
  });
};

export const updateB2bInbound = (data) => {
  return axios.request({
    url: `/warehouse/inbound/updateRecord/${data.id}`,
    method: "post",
    data,
  });
};

export const getB2bOutbound = (id) => {
  return axios.request({
    url: `/warehouse/outbound/getRecord/${id}`,
    method: "get",
  });
};

export const addB2bOutbound = (id, data) => {
  return axios.request({
    url: `/warehouse/outbound/addRecord/${id}`,
    method: "post",
    data,
  });
};

export const updateOutbound = (data) => {
  return axios.request({
    url: `/warehouse/outbound/updateRecord/${data.id}`,
    method: "post",
    data,
  });
};

export const changeSheet = (data) => {
  return axios.request({
    url: `/warehouse/b2bUnpack/getorderawb`,
    method: "post",
    data,
  });
};

export const del = (awbno) => {
  return axios.request({
    url: `/doubleClearance/delete/${awbno}`,
    method: "delete",
  });
};

export const getCharging = (awbno, cateID) => {
  return axios.request({
    url: `/doubleClearance/getCharging/${awbno}/${cateID}`,
    method: "get",
  });
};

export const getOrderCount = () => {
  return axios.request({
    url: `/doubleClearance/orderCount`,
    method: "get",
  });
};

export const uploadFiles = (data) => {
  return axios.request({
    url: `/doubleClearance/batchUpload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const uploadB2BFiles = (data) => {
  return axios.request({
    url: `/doubleClearance/batchUploadCost`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const uploadInboundFile = (data) => {
  return axios.request({
    url: `/doubleClearance/inboundUpload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const getPackList = (data) => {
  return axios.request({
    url: `/doubleClearance/boxList/${data.id}`,
    method: "post",
  });
};

export const readPackBox = (id) => {
  return axios.request({
    url: `/doubleClearance/readBox/${id}`,
    method: "post",
  });
};

export const uploadInfoFiles = (data) => {
  return axios.request({
    url: `/doubleClearance/extendUpload`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

// 批量信息上传
export const bachPack = (data) => {
  return axios.request({
    url: `/doubleClearance/singleUpload/`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const postPacking = (data) => {
  return axios.request({
    url: `/doubleClearance/batchUpload/`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const getChargingType = (params) => {
  console.log(params, 'params')
  return axios.request({
    url: `/common/charging`,
    method: "get",
    params
  });
};

export const getSystemCosting = (id) => {
  return axios.request({
    url: `/doubleClearance/defineCosting/${id}`,
    method: "get",
  });
}

// 审核接口
export const getAuditList = (id) => {
  return axios.request({
    url: `/doubleClearance/verifyBox/${id}`,
    method: "post",
  });
};

// 导出明细
export const exportBillDetails = (cnbNo) => {
  return axios.request({
    url: `/doubleClearance/exportFinance/${cnbNo}`,
    method: "get",
  });
};

export const checkWeight = (data) => {
  return axios.request({
    url: `/doubleClearance/confirmedWeight`,
    method: "post",
    data,
  });
};

export const getB2bType = () => {
  return axios.request({
    url: `/common/dblwhere`,
    method: "get",
  });
};

export const getGoodsInfo = (awbno) => {
  return axios.request({
    url: `/doubleClearance/getGoods/${awbno}`,
    method: "get",
  });
};

export const saveGoodsInfo = (data) => {
  return axios.request({
    url: `/doubleClearance/saveGoods/${data.id}`,
    method: "post",
    data,
  });
};


export const getRemarkDetail = (awbno) => {
  return axios.request({
    url: `/doubleClearance/financeRemarks/${awbno}`,
    method: "get",
  });
};


// 添加备注
export const addRemark = (data) => {
  return axios.request({
    url: `/doubleClearance/saveGoodsRemarks/${data.id}`,
    method: "post",
    data,
  });
};

// 批量下载箱单
export const downloadBox = (data) => {
  return axios.request({
    url: `/doubleClearance/batchDownload`,
    method: "post",
    data,
  });
};

// 获取报价信息
export const getDefList = (airwayNumber, params) => {
  return axios.request({
    url: `/finance/DblFinanceRule/getRule/${airwayNumber}`,
    method: "get",
    params
  });
};

// 设置数据列表
export const getFinanceData = (data) => {
  return axios.request({
    url: `/doubleClearance/${data.target_type == 2 ? 'getBranchFinanceData' : 'getFinanceData'}/${data.airway_number}/${data.id}`,
    method: "post",
    data,
  });
};

// 批量设置报价
export const batchSaveFinance = (data) => {
  return axios.request({
    url: `/doubleClearance/${data.target_type == 2 ? 'batchSaveBranchFinance' : 'batchSaveFinance'}/${data.airway_number}`,
    method: "post",
    data,
  });
};

// 关联报价导出
export const exportFinance = (data) => {
  return axios.request({
    url: `/doubleClearance/batchExport`,
    method: "post",
    data,
  });
};

// 获取服务项目
export const getWhService = () => {
  return axios.request({
    url: `/common/dblService`,
    method: "get",
  });
};

// 保存服务项目
export const saveService = (data) => {
  return axios.request({
    url: `/doubleClearance/saveService`,
    method: "post",
    data,
  });
};

// 获取服务项目详情
export const getServiceDetail = (airwayNumber) => {
  return axios.request({
    url: `/doubleClearance/getServiceList/${airwayNumber}`,
    method: "get",
  });
};

// 批量更新订单轨迹
export const batchUpdateTrack = (data) => {
  return axios.request({
    url: `/doubleClearance/batchTrace`,
    method: "post",
    data,
  });
};

// 客服名称
export const getUser = (data) => {
  return axios.request({
    url: `/common/bindUser`,
    method: "get",
    data,
  });
};

// 报价确认
export const confirmedFinance = (data) => {
  return axios.request({
    url: `/doubleClearance/confirmedFinance/` + data.airway_number,
    method: "post",
    data,
  });
};

export const makePaymentBill = (data) => {
  return axios.request({
    url: `/doubleClearance/billFinance/` + data.airway_number,
    method: "post",
    data,
  });
}

// 删除增值服务
export const deleteService = (airway_number, data) => {
  return axios.request({
    url: `/doubleClearance/delServiceFee/${airway_number}`,
    method: "post",
    data,
  });
};


export const batchService = (data) => {
  return axios.request({
    url: `/doubleClearance/batchService`,
    method: "post",
    data,
  });
};

export const batchSetAgentNumber = (data) => {
  return axios.request({
    url: `/doubleClearance/batchSetAgentNumber`,
    method: "post",
    data,
  });
};

export const modifyShipments = (data) => {
  return axios.request({
    url: `/doubleClearance/modifyShipments`,
    method: "post",
    data,
  });
};


export const batchSetRemarks = (data) => {
  return axios.request({
    url: `/doubleClearance/batchSetRemarks`,
    method: "post",
    data,
  });
};

export const costShare = (data) => {
  return axios.request({
    url: `/doubleClearance/costShare`,
    method: "post",
    data,
  });
};

export const uploadRemarks = (data) => {
  return axios.request({
    url: `/doubleClearance/uploadRemarks`,
    method: "post",
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: getToken(),
    },
    data,
  });
};

export const editTransport = (data) => {
  return axios.request({
    url: `/doubleClearance/editTransport`,
    method: "post",
    data,
  });
};

export const Del = (id) => {
  return axios.request({
    url: `/warehouse/inbound/delRecord/${id}`,
    method: "post",
  });
};

export const doubleFeright = (data) => {
  return axios.request({
    url: '/doubleClearance/batchSaveExtend',
    method: 'post',
    data
  })
}

export const errorOrder = (params) => {
  return axios.request({
    url: `/warehouse/b2bUnpack/getErrorCreateLog`,
    method: "get",
    params,
  });
};

export const delError = (data) => {
  return axios.request({
    url: '/warehouse/b2bUnpack/delErrorCreateLog',
    method: 'post',
    data
  })
}
export const fordel = (params) => {
  return axios.request({
    url: '/doubleClearance/fordel/' + params.airway_number,
    method: 'get',
    params
  })
}


export const exportDeliverty = (data) => {
  return axios.request({
    url: '/doubleClearance/exportDeliverty',
    method: 'post',
    data
  })
}

export const abnormalSave = (data) => {
  return axios.request({
    url: '/doubleClearance/abnormal/save',
    method: 'post',
    data
  })
}

export const abnormalInfo = (params) => {
  return axios.request({
    url: '/doubleClearance/abnormal/index/' + params.airway_number,
    method: 'get',
    params
  })
}

export const batchdel = (data) => {
  return axios.request({
    url: '/doubleclearance/batchdel',
    method: 'post',
    data
  })
}

export const uploadProofImage = (data) => {
  return axios.request({
    url: `/doubleclearance/uploadProofImage`,
    method: 'post',
    data
  })
}
